import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import App from "../components/App";
import Frame from "../components/Frame";
import SEO from "../components/SEO";

export default ({ location }) => (
  <App>
    <Header />
    <SEO page={{ title: "Privacy Policy", pathname: location.pathname }} />
    <Frame>
      <Content>
        <h1>Privacy Policy</h1>

        <p>This Privacy Policy describes how your personal information is collected, used, and shared when you visit michalzalecki.com (the “Site”).</p>

        <h2>PERSONAL INFORMATION WE COLLECT</h2>

        <p>When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as “Device Information.”</p>

        <p>We collect Device Information using the following technologies:</p>

        <ul>
          <li>Cookies are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit <a rel="noreferrer noopener" href="https://www.allaboutcookies.org">www.allaboutcookies.org</a>.</li>
          <li>Log files track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.</li>
          <li>Web beacons, tags, and pixels are electronic files used to record information about how you browse the Site.</li>
        </ul>

        <p>When we talk about “Personal Information” in this Privacy Policy, we are talking also about Device Information.</p>

        <h2>HOW DO WE USE YOUR PERSONAL INFORMATION?</h2>

        <p>We use the Device Information that we collect to help us improve and optimize our Site.</p>

        <h2>SHARING YOUR PERSONAL INFORMATION</h2>

        <p>The Site displays unobtrusive ads by BuySellAds (ads via Carbon) which advocate for consumer protection against data mining and privacy infringing advertising technologies. Here’s the specific information BuySellAds collects and why:</p>

        <ul>
          <li>IP address to determine geographic location.</li>
          <li>Browser type and operating system, as determined from user agent string. (We do not store the user agent string itself but do store a hash of the user agent.)</li>
          <li>Creative, ad zone, and publisher segment(s) to determine where impressions and clicks are happening.</li>
        </ul>

        <p>You can learn more about <a rel="noreferrer noopener" href="https://content.buysellads.com/publishers/what-data-does-buysellads-collect">what data BuySellAds collects</a>.</p>

        <h2>DO NOT TRACK</h2>

        <p>Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.</p>

        <h2>YOUR RIGHTS</h2>

        <p>If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.</p>

        <p>Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.  Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.</p>

        <h2>CHANGES</h2>

        <p>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.</p>

        <h2>CONTACT US</h2>

        <p>For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at michal@michalzalecki.com.</p>
      </Content>
    </Frame>
    <Footer />
  </App>
);

const Content = styled.div`
  padding: 26px 0 50px;
  grid-column: 5 / 21 !important;
  @media (max-width: 736px) {
    grid-column: 2 / 24 !important;
  }
`;
